import data from "@iconify-icons/mdi/magnify-plus";
import { axiosInstance } from "../../utils";

const actions = {
  FETCH_ORDERS_REQUESTED: "FETCH_ORDERS_REQUESTED",
  FETCH_ORDERS_SUCCEEDED: "FETCH_ORDERS_SUCCEEDED",
  FETCH_ORDERS_FAILED: "FETCH_ORDERS_FAILED",

  FETCH_ORDER_REQUESTED: "FETCH_ORDER_REQUESTED",
  FETCH_ORDER_SUCCEEDED: "FETCH_ORDER_SUCCEEDED",
  FETCH_ORDER_FAILED: "FETCH_ORDER_FAILED",

  ACCEPT_ORDER_REQUESTED: "ACCEPT_ORDER_REQUESTED",
  ACCEPT_ORDER_SUCCEEDED: "ACCEPT_ORDER_SUCCEEDED",
  ACCEPT_ORDER_FAILED: "ACCEPT_ORDER_FAILED",

  REJECT_ORDER_REQUESTED: "REJECT_ORDER_REQUESTED",
  REJECT_ORDER_SUCCEEDED: "REJECT_ORDER_SUCCEEDED",
  REJECT_ORDER_FAILED: "REJECT_ORDER_FAILED",

  SETTEL_ORDER_REQUESTED: "SETTEL_ORDER_REQUESTED",
  SETTEL_ORDER_SUCCEEDED: "SETTEL_ORDER_SUCCEEDED",
  SETTEL_ORDER_FAILED: "SETTEL_ORDER_FAILED",

  SETTLE_BULK_ORDER_REQUESTED: "SETTLE_BULK_ORDER_REQUESTED",
  SETTLE_BULK_ORDERS_SUCCESS: "SETTLE_BULK_ORDERS_SUCCESS",
  SETTLE_BULK_ORDERS_FAILED: "SETTLE_BULK_ORDERS_FAILED",

  DELETE_ORDER_REQUESTED: "DELETE_ORDER_REQUESTED",
  DELETE_ORDER_SUCCEEDED: "DELETE_ORDER_SUCCEEDED",
  DELETE_ORDER_FAILED: "DELETE_ORDER_FAILED",

  CANCEL_ORDER_REQUESTED: "CANCEL_ORDER_REQUESTED",
  CANCEL_ORDER_SUCCEEDED: "CANCEL_ORDER_SUCCEEDED",
  CANCEL_ORDER_FAILED: "CANCEL_ORDER_FAILED",

  CHANGE_SUPPLIER_REQUESTED: "CHANGE_SUPPLIER_REQUESTED",
  CHANGE_SUPPLIER_SUCCEEDED: "CHANGE_SUPPLIER_SUCCEEDED",
  CHANGE_SUPPLIER_FAILED: "CHANGE_SUPPLIER_FAILED",

  CHANGE_SERVICE_FEES_REQUESTED: "CHANGE_SERVICE_FEES_REQUESTED",
  CHANGE_SERVICE_FEES_SUCCEEDED: "CHANGE_SERVICE_FEES_SUCCEEDED",
  CHANGE_SERVICE_FEES_FAILED: "CHANGE_SERVICE_FEES_FAILED",

  CHANGE_ORDER_STATUS_REQUESTED: "CHANGE_ORDER_STATUS_REQUESTED",
  CHANGE_ORDER_STATUS_SUCCEEDED: "CHANGE_ORDER_STATUS_SUCCEEDED",
  CHANGE_ORDER_STATUS_FAILED: "CHANGE_ORDER_STATUS_FAILED",

  CHANGE_ORDER_REQUESTED: "CHANGE_ORDER_REQUESTED",
  CHANGE_ORDER_SUCCEEDED: "CHANGE_ORDER_SUCCEEDED",
  CHANGE_ORDER_FAILED: "CHANGE_ORDER_FAILED",

  SELECT_GIFT_REQUESTED: "SELECT_GIFT_REQUESTED",
  SELECT_GIFT_SUCCEEDED: "SELECT_GIFT_SUCCEEDED",
  SELECT_GIFT_FAILED: "SELECT_GIFT_FAILED",
  UPLOAD_CLIQ_PROOF_REQUESTED: "UPLOAD_CLIQ_PROOF_REQUESTED",
  UPLOAD_CLIQ_PROOF_SUCCEEDED: "UPLOAD_CLIQ_PROOF_SUCCEEDED",
  UPLOAD_CLIQ_PROOF_FAILED: "UPLOAD_CLIQ_PROOF_FAILED",

  MARK_ITEM_RETURNED_REQUESTED: "MARK_ITEM_RETURNED_REQUESTED",
  MARK_ITEM_RETURNED_SUCCEEDED: "MARK_ITEM_RETURNED_SUCCEEDED",
  MARK_ITEM_RETURNED_FAILED: "MARK_ITEM_RETURNED_FAILED",

  APPLY_COPAYMENT_REQUESTED: "APPLY_COPAYMENT_REQUESTED",
  APPLY_COPAYMENT_SUCCEEDED: "APPLY_COPAYMENT_SUCCEEDED",
  APPLY_COPAYMENT_FAILED: "APPLY_COPAYMENT_FAILED",

  ACCEPT_ITEM_RETURN_REQUESTED: "ACCEPT_ITEM_RETURN_REQUESTED",
  ACCEPT_ITEM_RETURN_SUCCEEDED: "ACCEPT_ITEM_RETURN_SUCCEEDED",
  ACCEPT_ITEM_RETURN_FAILED: "ACCEPT_ITEM_RETURN_FAILED",

  REJECT_ITEM_RETURN_REQUESTED: "REJECT_ITEM_RETURN_REQUESTED",
  REJECT_ITEM_RETURN_SUCCEEDED: "REJECT_ITEM_RETURN_SUCCEEDED",
  REJECT_ITEM_RETURN_FAILED: "REJECT_ITEM_RETURN_FAILED",

  CLEAR_MESSAGE: "CLEAR_MESSAGE",

  REFUND_ALL_ITEMS_REQUESTED: "REFUND_ALL_ITEMS_REQUESTED",
  REFUND_ALL_ITEMS_SUCCEEDED: "REFUND_ALL_ITEMS_SUCCEEDED",
  REFUND_ALL_ITEMS_FAILED: "REFUND_ALL_ITEMS_FAILED",

  acceptOrder: (params = undefined) => {
    return {
      type: actions.ACCEPT_ORDER_REQUESTED,
      payload: params,
    };
  },

  rejectOrder: (data = undefined) => {
    return {
      type: actions.REJECT_ORDER_REQUESTED,
      payload: data,
    };
  },

  fetchOrders: (params = undefined) => {
    return {
      type: actions.FETCH_ORDERS_REQUESTED,
      payload: params,
    };
  },

  fetchOrder: (params = undefined) => {
    return {
      type: actions.FETCH_ORDER_REQUESTED,
      payload: params,
    };
  },

  getOrder: async (params = undefined) => {
    const url = `orders/` + params?._id;

    try {
      const order = await axiosInstance.get(url);
      return order.data;
    } catch (error) {
      throw error;
    }
  },

  getOrders: async (params = undefined) => {
    const url = `orders`;

    // Base params (admin style)
    let finalParams = {
      ...params,
      status: params?.statistics ? null : params?.status,
    };

    // When the logged-in user is a supplier (role 1), match the mobile
    // getMyOrdersCall behaviour by scoping to this supplier via supplier_id.
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (user?.role === 1 && user?._id) {
        finalParams = {
          ...finalParams,
          supplier_id: finalParams?.supplier_id || user._id,
        };
      }
    } catch (e) {
      // ignore JSON errors and fall back to base params
    }

    try {
      const orders = await axiosInstance.get(url, { params: finalParams });
      if (params?.statistics) {
        const statisticsUrl = `accounting/statistics`;
        const statistics = await axiosInstance.get(statisticsUrl, {
          params: finalParams,
        });
        const data = {
          ...orders.data,
          ...statistics.data,
        };

        return data;
      }
      return orders.data;
    } catch (error) {
      throw error;
    }
  },

  acceptOrderApi: async (params = undefined) => {
    const url = `orders/accept/` + params?._id;

    try {
      const order = await axiosInstance.put(url);
      return order.data;
    } catch (error) {
      throw error;
    }
  },

  rejectOrderApi: async (data = undefined) => {
    const url = `orders/reject/` + data?._id;

    try {
      const order = await axiosInstance.put(url);
      return order.data;
    } catch (error) {
      throw error;
    }
  },

  settleBulkOrder: (data = undefined) => {
    return {
      type: actions.SETTLE_BULK_ORDER_REQUESTED,
      payload: data,
    };
  },

  settleBulkOrderApi: async (data = undefined) => {
    const url = `accounting/settle/bulk`;
    try {
      const order = await axiosInstance.post(url, data);
      return order?.data;
    } catch (error) {
      throw error;
    }
  },

  settleOrder: (data = undefined) => {
    return {
      type: actions.SETTEL_ORDER_REQUESTED,
      payload: data,
    };
  },

  settleOrderApi: async (params = undefined) => {
    const url = `accounting/settle/${params?._id}`;
    try {
      const order = await axiosInstance.post(url);
      return order?.data;
    } catch (error) {
      throw error;
    }
  },

  deleteOrder: (data = undefined) => {
    return {
      type: actions.DELETE_ORDER_REQUESTED,
      payload: data,
    };
  },

  deleteOrderApi: async (params = undefined) => {
    const url = `orders/${params?._id}`;
    try {
      const order = await axiosInstance.delete(url);
      return order?.data;
    } catch (error) {
      throw error;
    }
  },

  cancelOrder: (data = undefined) => {
    return {
      type: actions.CANCEL_ORDER_REQUESTED,
      payload: data,
    };
  },

  cancelOrderApi: async (params = undefined) => {
    const url = `orders/${params?._id}/cancel`;
    try {
      const order = await axiosInstance.put(url);
      return order?.data;
    } catch (error) {
      throw error;
    }
  },
  changeSupplier: (data = undefined) => {
    return {
      type: actions.CHANGE_SUPPLIER_REQUESTED,
      payload: data,
    };
  },

  changeSupplierApi: async (params = undefined) => {
    const url = `orders/change_supplier/${params?._id}`;
    try {
      const order = await axiosInstance.put(url, {
        supplier_id: params.supplier_id,
      });
      return order?.data;
    } catch (error) {
      throw error;
    }
  },
  changeServiceFees: (data = undefined) => {
    return {
      type: actions.CHANGE_SERVICE_FEES_REQUESTED,
      payload: data,
    };
  },

  changeServiceFeesApi: async (params = undefined) => {
    const url = `orders/change_service_fees/${params?._id}`;
    try {
      const order = await axiosInstance.put(url, { new_fees: params.new_fees });
      return order?.data;
    } catch (error) {
      throw error;
    }
  },
  changeOrderStatus: (data = undefined) => {
    return {
      type: actions.CHANGE_ORDER_STATUS_REQUESTED,
      payload: data,
    };
  },

  changeOrderStatusApi: async (params = undefined) => {
    const url = `orders/${params?.endpoint}`;
    try {
      const order = await axiosInstance.put(url, {
        proof_of_pickup: params.proofOfPickup,
        pickup_poa: params.proofOfPickupDelivery,
        dropoff_poa: params.proofOfDropoff,
      });
      return order?.data;
    } catch (error) {
      throw error;
    }
  },
  updateOrder: (data = undefined) => {
    return {
      type: actions.CHANGE_ORDER_REQUESTED,
      payload: data,
    };
  },
  selectGift: (data = undefined) => {
    return {
      type: actions.SELECT_GIFT_REQUESTED,
      payload: data,
    };
  },
  uploadCliqProof: (data = undefined) => {
    console.warn("eeeeee");
    return {
      type: actions.UPLOAD_CLIQ_PROOF_REQUESTED,
      payload: data,
    };
  },

  markItemReturned: (data = undefined) => {
    return {
      type: actions.MARK_ITEM_RETURNED_REQUESTED,
      payload: data,
    };
  },

  acceptItemReturn: (data = undefined) => {
    return {
      type: actions.ACCEPT_ITEM_RETURN_REQUESTED,
      payload: data,
    };
  },

  rejectItemReturn: (data = undefined) => {
    return {
      type: actions.REJECT_ITEM_RETURN_REQUESTED,
      payload: data,
    };
  },

  refundAllItems: (data = undefined) => {
    return {
      type: actions.REFUND_ALL_ITEMS_REQUESTED,
      payload: data,
    };
  },

  updateOrderApi: async (params = undefined) => {
    const url = `orders/${params?._id}`;
    try {
      const order = await axiosInstance.put(url, params?.order);
      return order?.data;
    } catch (error) {
      throw error;
    }
  },
  selectGiftApi: async (params = undefined) => {
    const url = `cart_items/select_gift/${params.index}`;

    try {
      const order = await axiosInstance.put(url, { gift_id: params?.gift_id });
      return order?.data;
    } catch (error) {
      throw error;
    }
  },
  uploadCliqProofApi: async (params = undefined) => {
    const url = `/orders/order/${params?._id}`;

    let bodyFormData = new FormData();
    bodyFormData.set("cliq_proof", params?.cliq_proof);
    bodyFormData.set("is_cliq", true);

    try {
      const order = await axiosInstance.put(url, bodyFormData);
      return order?.data;
    } catch (error) {
      throw error;
    }
  },

  markItemReturnedApi: async (params = undefined) => {
    const url = `orders/${params?.order_id}/items/${params?.item_index}/return`;

    try {
      const response = await axiosInstance.patch(url, {
        reason: params?.reason || "",
        quantity: params?.quantity,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  },

  applyCopayment: (params = undefined) => {
    return {
      type: actions.APPLY_COPAYMENT_REQUESTED,
      payload: params,
    };
  },

  applyCopaymentApi: async (params = undefined) => {
    const url = `orders/apply_copayment/${params?._id}`;
    try {
      const order = await axiosInstance.put(url, {
        copayment_percentage: params?.copayment_percentage
      });
      return order?.data;
    } catch (error) {
      throw error;
    }
  },

  acceptItemReturnApi: async (params = undefined) => {
    const url = `orders/${params?.order_id}/items/${params?.item_index}/accept_return`;

    try {
      const response = await axiosInstance.patch(url, {
        quantity: params?.quantity,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  },

  rejectItemReturnApi: async (params = undefined) => {
    const url = `orders/${params?.order_id}/items/${params?.item_index}/reject_return`;

    try {
      const response = await axiosInstance.patch(url);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },

  clearMessage: () => {
    return {
      type: actions.CLEAR_MESSAGE,
    };
  },

  refundAllItemsApi: async (params = undefined) => {
    const url = `orders/${params?.order_id}/refund-all-items`;

    try {
      const response = await axiosInstance.post(url, {
        reason: params?.reason || "",
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
